import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

import ContactMediumItem from "./ContactMediumItem";

const ContactItem = ({first_name, last_name, communication_methods}) => {

    return (
            <div className="d-flex flex-column align-items-start justify-content-center border-right mr-2 pr-2 pb-2">
                <h7>{first_name} {last_name}</h7>
                {communication_methods &&
                    communication_methods.length &&
                    <div className="d-flex flex-column align-items-start justify-content-around">
                        {communication_methods.map(({contact_info, contact_medium}) => (
                            <ContactMediumItem info={contact_info} icon="at" className="mb-1" color="#ffc658"/>
                        ))}
                    </div>
                }
            </div>
    )

}

ContactItem.propTypes = {
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    communication_methods: PropTypes.array,
}

export default ContactItem